<template>
  <div class="user-profile-setting-gallery">
    <Card shadow :padding="15" v-if="gallery.activity">
      <p style="margin-bottom:10px">
        <span><b>Profile pictures</b>
          <small style="display:block;color:#aaa" v-if="!$store.state.supportPush">
          You can upload maximum of 3 pictures (Visible: <b>Publicly</b>).</small>
        </span>
      </p>
      <span
        v-if="gallery.activity && gallery.activity.total > 0 && !i.isDeleted"
        v-for="(i,k) in items"
        :isNew="false" :key="i.guid" class="image-block">
        <Item :isNew="false" :item="i"></Item>
      </span>
      <span v-if="gallery.activity && gallery.activity.total < 3" v-for="(i) in 1" :key="i" class="image-block">
        <Item :item="activityData" :isNew="true" ></Item></span>
    </Card>
  </div>
</template>

<script>
import Item from '@/views/UserProfileSettingGalleryItemComponent'
import _ from 'lodash'

export default {
  components: {
    Item
  },
  props: {
    profile: {
      type: Object
    }
  },
  data() {
    return {
      activityData: _.cloneDeep(Cons[0].ACTIVITY),
      maxGallery: 3
    }
  },
  computed: {
    gallery: {
      get() {
        return this.$store.state.gallery.data
      }
    },
    items() {
      return this.$store.state.gallery.data.activity.careplan_item
    },
    info() {
      return this.profile
    }
  },
  methods: {
    getKey(i) {
      return i.id || i.guid
    }
  },
  mounted() {
    this.$store.dispatch('gallery/getUserGallery', {id: this.info.careplan_id})
  },
}
</script>

<style scoped>
  .image-block {
    display:inline-block;
    height:60px;
    position:relative;
    margin:0 10px 0 0;
  }
</style>
